import { TFunction } from 'i18next'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import IconCarbonEdit from '@/shared/icons/IconCarbonEdit'
import IconCarbonPower from '@/shared/icons/IconCarbonPower'
import IconCarbonRotate360 from '@/shared/icons/IconCarbonRotate360'
import IconCarbonTrashCan from '@/shared/icons/IconCarbonTrashCan'

import { WebsalesUser } from '../types'
import { ActionsCell, ActionsRow, StatusText, Td } from './styled-components'

interface WebsalesUserRowProps {
  websalesUser: WebsalesUser
  canDelete: boolean
  t: TFunction
  onEdit: (websalesUser: WebsalesUser) => void
  onToggleStatus: (websalesUser: WebsalesUser) => void
  onDelete: (websalesUserId: number | string) => void
  onRegeneratePassword: (websalesUserId: number | string) => void
}

const WebsalesUserRow = ({
  websalesUser,
  canDelete,
  t,
  onEdit,
  onToggleStatus,
  onDelete,
  onRegeneratePassword,
}: WebsalesUserRowProps) => (
  <tr>
    <Td>{websalesUser.id}</Td>
    <Td>{websalesUser.username}</Td>
    <Td>
      <StatusText $active={websalesUser.is_active}>
        {t(
          websalesUser.is_active
            ? 'websalesUsersManagement:table.active'
            : 'websalesUsersManagement:table.inactive',
        )}
      </StatusText>
    </Td>
    <Td>{websalesUser.origin ? t(`websalesUsersManagement:origins.${websalesUser.origin}`) : '-'}</Td>
    <Td>{websalesUser.created_at ?? ''}</Td>
    <ActionsCell>
      <ActionsRow>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          id={`websales-user-${websalesUser.id}-edit-btn`}
          onClick={() => onEdit(websalesUser)}
          endEnhancer={() => <IconCarbonEdit size={16} color='white' />}
        >
          {t('common:edit')}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          id={`websales-user-${websalesUser.id}-toggle-status-btn`}
          onClick={() => onToggleStatus(websalesUser)}
          endEnhancer={() => <IconCarbonPower size={16} color='white' />}
        >
          {websalesUser.is_active ? t('common:deactivate') : t('websalesUsersManagement:table.activate')}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          id={`websales-user-${websalesUser.id}-regenerate-password-btn`}
          onClick={() => onRegeneratePassword(websalesUser.id)}
          endEnhancer={() => <IconCarbonRotate360 size={16} color='white' />}
        >
          {t('websalesUsersManagement:table.regenerate_password')}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          id={`websales-user-${websalesUser.id}-delete-btn`}
          hidden={!canDelete}
          onClick={() => onDelete(websalesUser.id)}
          endEnhancer={() => <IconCarbonTrashCan size={16} color='white' />}
        >
          {t('common:delete')}
        </SDButton>
      </ActionsRow>
    </ActionsCell>
  </tr>
)

export default WebsalesUserRow
